import { render, staticRenderFns } from "./ShippingAddressDetails.vue?vue&type=template&id=2fd029f5&scoped=true"
import script from "./ShippingAddressDetails.vue?vue&type=script&lang=js"
export * from "./ShippingAddressDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd029f5",
  null
  
)

export default component.exports